import React from 'react';
import { Leaf, Heart, Award, Recycle, MapPin, Mail, Phone } from 'lucide-react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1 className="about-hero-title">About House of Microgreens</h1>
          <p className="about-hero-subtitle">
            Growing fresh, nutrient-dense microgreens for a healthier Bangalore
          </p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="about-story">
        <div className="container">
          <div className="story-content">
            <h2>Our Story</h2>
            <p>
              House of Microgreens was born from a simple belief: everyone deserves access to fresh, 
              nutrient-dense food grown with care and delivered to their doorstep. We started our 
              journey in Bangalore with a mission to bring the power of microgreens to health-conscious 
              individuals and families.
            </p>
            <p>
              Microgreens are young vegetable greens that are packed with nutrients—up to 40 times more 
              concentrated than their mature counterparts. They're not just a garnish; they're a 
              powerhouse of vitamins, minerals, and antioxidants that can transform your meals and 
              boost your health.
            </p>
            <p>
              Every batch of microgreens we grow is cultivated with love, using organic methods and 
              sustainable practices. From seed to harvest, we ensure the highest quality standards, 
              so you receive the freshest greens possible.
            </p>
          </div>
        </div>
      </section>

      {/* Our Values Section */}
      <section className="about-values">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <Leaf size={32} strokeWidth={1.5} />
              </div>
              <h3>Freshness</h3>
              <p>
                Harvested daily and delivered within 24 hours to ensure maximum freshness and 
                nutritional value. No storage, no preservatives—just pure, fresh greens.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Heart size={32} strokeWidth={1.5} />
              </div>
              <h3>Health</h3>
              <p>
                Packed with vitamins, minerals, and antioxidants, our microgreens are grown to 
                support your health journey. Clean eating starts with clean produce.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Award size={32} strokeWidth={1.5} />
              </div>
              <h3>Quality</h3>
              <p>
                We maintain strict quality control from seed selection to packaging. Every batch 
                is carefully monitored to meet our high standards.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <Recycle size={32} strokeWidth={1.5} />
              </div>
              <h3>Sustainability</h3>
              <p>
                Organic growing methods, minimal water usage, and eco-friendly packaging. We care 
                about your health and the planet's future.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Offer Section */}
      <section className="about-offer">
        <div className="container">
          <h2 className="section-title">What We Offer</h2>
          <div className="offer-content">
            <div className="offer-item">
              <h3>Monthly Subscriptions</h3>
              <p>
                Get fresh microgreens delivered to your door every week. Our subscription plans 
                are designed for regular consumers who want to make healthy eating a habit.
              </p>
            </div>

            <div className="offer-item">
              <h3>One-Time Orders</h3>
              <p>
                Not ready to commit? Try our one-time orders and experience the difference fresh 
                microgreens can make to your meals.
              </p>
            </div>

            <div className="offer-item">
              <h3>Sample Packs</h3>
              <p>
                New to microgreens? Start with our affordable sample pack (₹299) and discover 
                which varieties you love the most.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Coverage Section */}
      <section className="about-coverage">
        <div className="container">
          <div className="coverage-content">
            <div className="coverage-icon">
              <MapPin size={48} strokeWidth={1.5} />
            </div>
            <h2>Serving Bangalore</h2>
            <p>
              Currently, we deliver to select areas in Bangalore. We're constantly expanding our 
              delivery network to bring fresh microgreens to more neighborhoods. Check your pincode 
              on our homepage to see if we deliver to your area.
            </p>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="about-contact-cta">
        <div className="container">
          <h2>Get in Touch</h2>
          <p>Have questions or want to learn more about our microgreens?</p>
          <div className="contact-methods">
            <a href="mailto:support@houseofmicrogreens.in" className="contact-method">
              <Mail size={24} />
              <span>support@houseofmicrogreens.in</span>
            </a>
            <a href="tel:+919876543210" className="contact-method">
              <Phone size={24} />
              <span>+91 98765 43210</span>
            </a>
          </div>
          <a href="/contact" className="btn-primary">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
